import React from 'react';
import BaseComponent from "../../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import InputDropDown from "../../inputFields/dropdown/InputDropDown";
import {MenuItem, ToggleButton, ToggleButtonGroup} from "@mui/material";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import PagerButtonBuilder from "./PagerButtonBuilder";

class Pager extends BaseComponent {

  buildButtons() {
    let {totalRows, pageSize, actualPage} = this.props;
    let numOfPages = Math.ceil(totalRows / pageSize);
    if (numOfPages <= 10) {
      return PagerButtonBuilder.buildButtonLessEqual10(numOfPages, actualPage);
    } else {
      return PagerButtonBuilder.buildButtonGrater10(numOfPages, actualPage);
    }
  };

  onPageChanged = (e) => {
    let newActualPage = e.currentTarget.value;
    //um unnötige Reloads zu sparen, wird nicht geladen, wenn die Page nicht gewechselt wurde,
    // die Prüfung mit -1 ist notwendig, da sonst alle Daten aus der Tabelle gefragt werden.
    if (newActualPage !== this.props.actualPage && newActualPage !== '-1') {
      this.props.onPageChanged(parseInt(e.currentTarget.value));
    }
  }

  render() {
    let {totalRows, actualPage, pageSize, onPageSizeChanged} = this.props;

    actualPage = String(actualPage);
    return <HorizontalLayout className='gap-2' widthFit>
      <InputDropDown
        width={80}
        fullWidth={false}
        size='small'
        disabled={totalRows < 10}
        value={pageSize}
        onChange={onPageSizeChanged}>
        <MenuItem value={10}>10</MenuItem>
        <MenuItem value={20}>20</MenuItem>
        <MenuItem value={50}>50</MenuItem>
        <MenuItem value={80}>80</MenuItem>
        <MenuItem value={100}>100</MenuItem>
      </InputDropDown>
      <ToggleButtonGroup
        color='primary'
        value={[actualPage]}
        onChange={this.onPageChanged}
        size='small'>
        <ToggleButton value='-1' size='small'>Total: {totalRows}</ToggleButton>
        {this.buildButtons()}
      </ToggleButtonGroup>
    </HorizontalLayout>;
  }
}

Pager.propTypes = {
  onPageChanged: PropTypes.func.isRequired,
  totalRows: PropTypes.number.isRequired,
  onPageSizeChanged: PropTypes.func.isRequired,
  actualPage: PropTypes.number.isRequired,
}

export default Pager;
